export const FILE_UPLOAD_CELL_SLICE = 'FILE_UPLOAD_CELL_SLICE';
